import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import contactAdminService from '../../../services/adminService/ContactAdminService';

const SendMailModal = ({ selectRecord, refetch, handleCancel }) => {
    const [form] = useForm()
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        form.setFieldsValue({
            title: `Phản hồi khiếu nại giao dịch - ${selectRecord?.code}`,
            reply: selectRecord?.reply,
        });
    }, [selectRecord]);

    const handleOk = (values) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("title", values?.title);
        const data = contactAdminService.sendMailContact(selectRecord?.id, formData);

        data.then((res) => {
            if (res?.status === 200) {
                toast.success(res?.message);
                form.resetFields();
                handleCancel()
                refetch();
            } else {
                toast.warn(res?.message);
            }
            setLoading(false);
        }).catch((err) => {
            toast.error(err);
            setLoading(false);
        });
    };
    const handleModalCancel = () => {
        form.resetFields();
        handleCancel();
    };

    return (
        <>
            <Form
                name="status"
                onFinish={handleOk}
                autoComplete="off"
                layout='vertical'
                form={form}

            >
                <Form.Item
                    label="Tiêu đề Email "
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập tiêu đề!",
                        },
                    ]}
                >
                    <Input.TextArea rows={4} placeholder="Nội dung tiêu đề – Mã yêu cầu" />

                </Form.Item>
                <Form.Item
                    label="Nội dung phản hồi "
                    name="reply"
                >
                    <Input.TextArea rows={4} readOnly />

                </Form.Item>
                <Form.Item className='d-flex justify-content-end'>
                    <Button type="default" onClick={handleModalCancel}>
                        Hủy
                    </Button>
                    <Button type="primary" htmlType="submit" className='ms-2' loading={loading}>
                        Gửi
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default SendMailModal